"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = require("../index");
exports.POSListingAPI = {
    getPOSListings: function (companyId, locationId, filter) {
        return index_1.axios
            .get("/api/v1/company/" + companyId + "/location/" + locationId + "/posListings", {
            params: filter,
        })
            .then(function (response) {
            var listings = response.data.listings;
            return listings;
        });
    },
    getPosListingQuantity: function (companyId, locationId, posListingId) {
        return index_1.axios
            .request({
            url: "/api/v1/company/" + companyId + "/location/" + locationId + "/posListings/" + posListingId + "/quantity",
            timeout: 5000,
        })
            .then(function (response) {
            var quantity = response.data.quantity;
            return quantity;
        });
    },
};
//# sourceMappingURL=POSListingAPI.js.map